import React, { useCallback, useEffect, useState } from "react";
import logo from "../../assets/img/reduce-bill.png";
import catalystlogo from "../../assets/image/catalyst.jpg";
import { RepairStatusField } from "../../models/Repair/Repair";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { PremisesType } from "../../models/Customer/Premises";
import Repair, { RepairsResponse } from "../../models/Repairs";
import * as api from "../../api";
import "../../compositions/Customer360View/index.scss";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { RouteComponentProps, useHistory, useLocation } from "react-router-dom";
import {
  AssocitaedAssetsType,
  RelatedPremisesType,
} from "../../models/Property/AdminUnits";
import { detectMobile, formatDate, hasOverdueService, isNullOrUndefined } from "../../utils/formatting";
import Tenancies from "../../models/Customer/Tenancies";
import Customer, {
  CustomerResponse,
  TenancySummary,
} from "../../models/Customer";
import { isUndefinedNullOrEmpty } from "../../utils/translation/helper";
import CustomerIdentifierModel from "../../models/Customer/CustomerIdentifierModel";
import { updateDashboardForm } from "../../ducks/redux/actions/dashboardReducer.actions";
import {
  appConfigCovidToggle,
  appConfigVandalismToggle,
  appConfigToggle,
  getCustomerId,
  selectedTenacyType,
  workOrderRepairObject,
  appConfigCaseCardToggle,
  saveCustomerphoneNumber,
  getReferenceNumber,
  getPrefferenceNumber,
  getHeatingHotWaterCase,
  getDeterminedContractorDetails,
  saveAssetId,
  saveCustomerDetails,
  savePreviousPage,
  saveSupplimentaryCodes,
  appConfigisDMCEnabledToggle,
  dmcWorkOrderRepairObject
} from "../../ducks/redux/actions/getAddress";
import { BalanceType } from "../../models/Accounts/BalanceType";
import AccountDetails, {
  TransactDeatils,
} from "../../models/Accounts/AccountDetails";
import LoadingSpinner from "../../storybook/LoadingSpinner";
import { trackEvent, trackException } from "../../appInsights/TelemetryService";
import { v4 } from "uuid";
import {
  userChosenPropertyId,
  userChosenPropertyType,
  userChosenPropertyAddress,
  userChosenRepairLocationId,
  userChosenRepairLocation,
  userChosenHighLevelDescription,
  userChosenSupplementaryQuestions,
  userChosenEmergencyQuestion,
  userChosenDuplicateQuestion,
  userChosenAdditionalDescription,
  userChosenVandalismQuestion,
  userChosenVandalismAdditionalInformation,
  userChosenCovidQuestion,
  userChosenVulnerabilityQuestion,
  userChosenVulnerabilityAdditionalInformation,
  userChosenContactDetails,
  userChosenUPRN,
  userChosenSOR,
  userChosenSTATUS,
  userChosenEligibilityErrorCode,
  loginTime,
  loginStatus,
  initialLoginTime,
  userChosenContactPhone,
  userChosenContactName,
  userChosenRelationDetails,
  userProfileETag,
  userProfileData,
  resumeDraftRepair,
  userChosenIsReporter,
  userChosenIsError,
  userChosenResumeRepair,
  loadDuplicateRepairPage,
  userCreatedNewRepair,
  getAllAssetIdentifiers,
  validateCatalystCustomer,
  validateCatalystDisabledArea,
  catalystWorkOrderToggleValue,
  clearMediaFiles,
  selectedTabValue,
  showMenuTabs,
  showFooter,
  getBlockIdentifier,
  assetRegion,
  userNavigatedFrom,
  userChosenAccountNumber,
  validateCaseCatalystToggle,
  boroughName,
  isMyPbRepairsMaintainence,
  userGetRepairData,
  isEICRCardToggle,
  isGASCardToggle,
  DMCChecksavedAnswer,
  originalRepairAppointmentData,
  dmcRepairAppointmentData,
  calendarPageIndex,
  originalRepairSelectedSlotData,
  dmcRepairSelectedSlotData,
  originalRepairAppointmentWillNotBeCreated,
  dmcRepairAppointmentWillNotBeCreated,
  selectedTenancyGroup,
  saveEmailCopyRadioValue,
} from "../../ducks/redux/actions/userChoices";
import { RepairChannel } from "../../models/Repair/RepairChannel";
import { defaultSearchArea, defaultSearchRepairStatus, defaultSearchSortByOrder, repairDefaultAssocitaedAsset, repairHistoryData, repairSearchTerm } from "../../ducks/redux/actions/historicRepair";
import MyMessagesCard from "../MyMessages/MyMessagesCard";
import CaseCard from "../Cases/CaseCard";
import { CASE_SELECTED_TENANCY } from "../../ducks/redux/actionTypes";
import { clearReferralInformation, comingFromCaseJourneySuccess, comingFromRepairJourneySuccess, RemoveAllDMCData, saveCustomerRentDetails, saveCustomerUCFlag, saveSelectedSlotDate, savingCalenderIndex, savingcalenderTrackValue, savingDmcCalenderIndex, savingDmcCalenderTrackValue, setTriageRepair } from "../../ducks/redux/actions/FinancialReferral";
import {
  CASE_SELECTED_ANSWERS,
  CLEAR_CASE_STATE,
} from "../../ducks/redux/actionTypes";
import HighRise from "../HighRise";
import Message from "../../storybook/Message"
import Button from "../../storybook/Button";
import SuccessMessage from "../SuccessMessage";
import GasBoilerServicing from "../gasService/GasBoilerCard";
import EICRCard from "../gasService/EICRCard";
import { getValueOrDefault } from "../../utils/NullCheck";
import { Helper } from "../../utils/Helper/HelperUtil";
import { EMAContractorType } from "../../models/Repair/Contractor";
import { resetHazardAssessmentData, saveHHSRSAssessmentCompleted } from "../../ducks/redux/actions/hazardAssessment";

enum UserNavigatedStreams {
  CaseFinalConfirmation = "CaseFinalConfirmation",
};

interface Customer360ViewProps extends RouteComponentProps<any> { }
const Customer360View: React.FC<Customer360ViewProps> = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [isAccount, setIsAccount] = useState(false);
  const [isVisible, setIsVisible] = useState("none");
  const [balanceCss, setBalanceCss] = useState("color-black pb-20")
  const [isArrear, setIsArrear] = useState(false)

  let assetBlockPropertyIds: any = [];
  const [financialReferralToggle, setFinancialReferralToggle] = useState("true")

  enum TenancyTypeMappingEnum {
    AGENCY = "AGENCY",
    COM1 = "COM1",
    HMBY2010 = "HMBY2010",
    OFFICE = "OFFICE",
    USENOCCU = "USENOCCU",
  }
  const RepairBlockMap = {
    Property: " property",
    "Divided block": " block",
    Block: " block",
    Estate: " estate",
  };
  const [defaultAssociatedAsset, setDefaultAssociatedAsset] = useState("");
  const [area, setArea] = useState(false);
  const [isCustInfo, setIsCustInfo] = useState(false);
  const customerIdValue = useSelector(
    (state: any) => state.addresses?.customerid
  );
  const blockAssetId = useSelector((state: any) => state.userChoicesReducer?.blockIdentifier);
  const array: Repair[] = [];
  const [custResponse, setCustResponse] = useState<CustomerResponse>();
  const [customerContact, setCustomerContact] = useState<Customer>();
  const [accountDetails, setAccountDetails] = useState<AccountDetails>();
  const arrayArea: Array<{ key: string; value: string }> = [];
  const [associatedAssetList, setAssociatedAssetsList] = useState(arrayArea);
  const [showMyMessages, setShowMyMessages] = useState();
  const [catalystCustomer, setCatalystCustomer] = useState(false);
  const [catalystCaseCardToggle, setCatalystCaseCardToggle] = useState("false");
  const [catalystWorkOrderToggle, setCatalystWorkOrderToggle] =
    useState("false");
  const [catalystRepairDisabledAreas, setCatalystRepairDisabledAreas] = useState(false);
  const [isUserRegistered, setIsUserRegistered] = useState(false);

  const [isRepairsCardError, setIsRepairsCardError] = useState(false);
  const [EICRserviceAlert, setEICRServiceAlert] = useState("");
  const [GASserviceAlert, setGASServiceAlert] = useState("");

  const isCatalyst = useSelector(
    (state: any) => state.userChoicesReducer?.isCatalystCustomer
  );

  const [assetIdentifiersAll, setassetIdentifiersAll] = useState("");
  const loggedInStatus = useSelector(
    (state: any) => state?.userChoicesReducer?.loginStatus
  );
  let PropertyId = useSelector(
    (state: any) => state.userChoicesReducer?.userChosenPropertyId
  );

  let userNavigatedStream = useSelector(
    (state: any) => state.userChoicesReducer?.userNavigatedFrom
  );

  const [assetProperty, setAssetProperty] = useState(PropertyId);
  let [GASPropsData, setGASPropsData] = useState<any>();
  let [EICRropsData, setEICRropsData] = useState<any>();
  const [EICRCardToggleValue, setEICRCardToggleValue] = useState("false");
  const [DGASCardToggleValue, setDGASCardToggleValue] = useState("false");
  const queryStringSearch = useLocation().search;

  const appConfigValue = useSelector(
    (state: any) => state?.addresses?.toggleValue
  );

  const appCaseCardconfigValue = useSelector(
    (state: any) => state?.addresses?.caseCardtoggleValue
  )

  const isMyPBMaintenance = useSelector(
    (state: any) => state?.userChoicesReducer?.isMyPbRepairsMaintainence
  );

  const MyPeabodyEICRCardToggle = "isshowmypeabodyeicrcard"
  const MyPeabodyDGASCardToggle = "isshowmypeabodygasboilercard"

  const dampAndMouldDescription = (data: any) => {
    data.forEach((wo: any) => {
      if (wo.description === "Investigate damp or mould") {
        wo.description = "Inspect Damp and Mould";
      }
    });
    return data
  }


  const getIsShowMyPeabodyAssetComplianceDataToggle = async () => {
    try {
      const EICRCardToggle = await api.GetAppConfigToggleValue(MyPeabodyEICRCardToggle);
      const GASCardToggle = await api.GetAppConfigToggleValue(MyPeabodyDGASCardToggle);
      if (EICRCardToggle) {
        setEICRCardToggleValue(EICRCardToggle.value);
        dispatch(isEICRCardToggle(EICRCardToggle.value));
      }
      if (GASCardToggle) {
        setDGASCardToggleValue(GASCardToggle.value);
        dispatch(isGASCardToggle(GASCardToggle.value));
      }
    } catch (error) {
      console.error("Error fetching toggle values:", error);
    }
  }

  const getGasBoilerData = useCallback(async (assetId: string) => {
    const gasBoiler = t("Gas_Boiler_Card");
     const EICR = t("Electical_Service_Card")
    try {
      const [res, res1] = await Promise.allSettled([
        api.getServiceCard(assetId, EICR,  false),
        api.getServiceCard(assetId, gasBoiler,  false)
      ]);

        if (res.status === 'fulfilled' && !isNullOrUndefined(res.value)) {
          
          const EICRData = res.value?.filter((appliance: any) => appliance?.applianceType === 'EICREQUI');
          setEICRropsData(EICRData);
          if (EICRData && hasOverdueService(EICRData?.[0]?.nextServiceDueDate)) {
            setEICRServiceAlert(`There is an Electrical service overdue for this property. Please contact ${getValueOrDefault(EICRData?.[0]?.contractor?.name)} on ${getValueOrDefault(EICRData?.[0].contractor?.phoneNumber)} to schedule a service visit.`);
          }
          else {
            setEICRServiceAlert("");
          }
        }
        if (res1.status === 'fulfilled' && !isNullOrUndefined(res1.value)) {
          const gasBoilerData = res1.value?.filter((appliance: any) => appliance?.applianceType === 'GASBOIL');
          setGASPropsData(gasBoilerData)
          if (gasBoilerData && hasOverdueService(gasBoilerData?.[0]?.nextServiceDueDate)) {
          setGASServiceAlert(`There is a Gas boiler service overdue for this property. Please contact ${getValueOrDefault(gasBoilerData?.[0]?.contractor?.name)} on ${getValueOrDefault(gasBoilerData?.[0]?.contractor?.phoneNumber)} to schedule a service visit.`);
          }else {
            setGASServiceAlert("");
          }
        }
      
     } catch (e: any) {
      console.log(e)
    }
  }, [])


  const customerDetails: CustomerResponse = useSelector(
    (state: any) => state.addresses.saveCustomerDetails
  );

  const isMobile = detectMobile();

  const getFinancialReferralToggleValue = async () => {
    try {
      const response = await api.GetAppConfigToggleValue("IsMyPeabodyCatalystFinancialEnquiry");
      setFinancialReferralToggle(response.value)
    } catch (e) {
      console.error(e);
      dispatch(showMenuTabs(false));
      dispatch(savePreviousPage(props.location.pathname));
      props.history.push('/customerApiErrorPage');
    }
  }

  const getCaseCardRequiredToggle = async () => {
    try {
      const response = await api.GetAppConfigToggleValue(
        "mypeabodycatalystcases"
      );
      setCatalystCaseCardToggle(response?.value);
      dispatch(validateCaseCatalystToggle(response?.value))
    } catch (e: any) {
      console.log(e);
    }
  };

  const getWorkOrderRequiredToggle = async () => {
    try {
      const response = await api.GetAppConfigToggleValue(
        "mypeabodycatalystworkorders"
      );
      setCatalystWorkOrderToggle(response?.value);
      dispatch(catalystWorkOrderToggleValue(response?.value));
    } catch (e: any) {
      console.log(e);
    }
  };


  const [repairList, setRepairList] = useState(array);

  let newAssociatedAssets: any[] = [];
  const customerIdentifierModel = new CustomerIdentifierModel();

  useEffect(() => {
    if (!defaultAssociatedAsset || defaultAssociatedAsset.trim() === "") {
      return;
    }
    if (userNavigatedStream === UserNavigatedStreams.CaseFinalConfirmation) {
      window.scrollTo(0, document.body.scrollHeight);
    }
    const timerId = setTimeout(() => {
      getGasBoilerData(defaultAssociatedAsset);
    }, 4200);

    return () => {
      clearTimeout(timerId);
    };
  }, [defaultAssociatedAsset])

  useEffect(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.get("code")) {
      url.searchParams.delete("code");
      url.searchParams.delete("state");
      url.searchParams.delete("session_state");
      window.history.replaceState({}, document.title, url.pathname);
    }
    setIsLoading(true)
    let timerId: any;
    (async () => {
      trackEvent("Customer360View");
      dispatch(showMenuTabs(true));
      dispatch(showFooter(true));
      dispatch(selectedTabValue("home"))
      clearReduxStore();
      timerId = setTimeout(() => {
        getIsShowMyPeabodyAssetComplianceDataToggle()
      }, 4200);
      try {
        const paramError =
          new URLSearchParams(queryStringSearch).get("error") || "";
        if (paramError === "access_denied" || paramError === "server_error") {
          const paramResetPassword =
            new URLSearchParams(queryStringSearch).get("state") || "";
          const paramError =
            new URLSearchParams(queryStringSearch).get("error_description") ||
            "";
          const _customerId = localStorage.getItem("customerId") || "";
          let error = "AADB2C99002";
          if (paramError.includes(error)) {
            dispatch(userChosenIsError(true));
            dispatch(showMenuTabs(false));
            dispatch(savePreviousPage(props.location.pathname));
            props.history.push('/customerApiErrorPage');
            return;
          }
          if (
            !isUndefinedNullOrEmpty(_customerId) &&
            paramResetPassword === "changepassword"
          ) {
            customerIdentifierModel.customerId = _customerId;
            dispatch(updateDashboardForm(_customerId));
            dispatch(getCustomerId(_customerId));
            dispatch(loginStatus(true));
            getCustomer360DetailsBind(_customerId);
            history.push("/customer360View");
          } else {
            history.push("/startpage");
            return;
          }
        }
        if (
          isUndefinedNullOrEmpty(loggedInStatus) &&
          paramError !== "access_denied" &&
          paramError !== "server_error"
        ) {
          const authCode =
            new URLSearchParams(queryStringSearch).get("code") || "";
          if (!isUndefinedNullOrEmpty(authCode)) {
            dispatch(showMenuTabs(true));
            dispatch(showFooter(true));
            try {
              localStorage.setItem("corelationId", v4());
              localStorage.setItem("sessionId", v4());

              if (authCode === "signout") {
                return;
              }
              let responseData: string = "";
              const state =
                new URLSearchParams(queryStringSearch).get("state") || "";
              if (state === "changepassword") {
                responseData = await api.GetCustomerId(
                  authCode,
                  "changepassword"
                );
              } else if (state === "registration") {
                setIsUserRegistered(true);
                responseData = await api.GetCustomerId(
                  authCode,
                  "registration"
                );
              } else {
                responseData = await api.GetCustomerId(authCode, "login");
              }
              Promise.all([responseData]).then(async (responseResults) => {
                if (responseResults[0]) {
                  const utcLogintime = new Date().toISOString();
                  if (isUndefinedNullOrEmpty(responseResults[0])) {
                    dispatch(loginStatus(false));
                    return;
                  }
                  customerIdentifierModel.customerId = responseResults[0];
                  dispatch(loginTime(utcLogintime));
                  dispatch(initialLoginTime(utcLogintime));
                  dispatch(
                    updateDashboardForm(customerIdentifierModel?.customerId)
                  );
                  dispatch(getCustomerId(customerIdentifierModel.customerId));
                  dispatch(loginStatus(true));
                  localStorage.setItem(
                    "customerId",
                    customerIdentifierModel?.customerId
                  );
                  dispatch(workOrderRepairObject(null));
                  getCustomer360DetailsBind(customerIdentifierModel.customerId);
                }
              });
            } catch (e: any) {
              const _channel = process.env.REACT_APP_X_CHANNEL_IDENTIFIER;
              const _customerId = localStorage.getItem("customerId") || "";
              const _corelationId = localStorage.getItem("corelationId") || "";
              const _sessionId = localStorage.getItem("sessionId") || "";
              trackException(
                e,
                _channel,
                _customerId,
                _corelationId,
                _sessionId
              );
              console.error(e);
              dispatch(showMenuTabs(false));
              dispatch(savePreviousPage(props.location.pathname));
              props.history.push('/customerApiErrorPage');
            }
          }
          else {
            props.history.push("/startpage");
          }
        } else {
          if (loggedInStatus && !isUndefinedNullOrEmpty(customerIdValue)) {
            getCustomer360DetailsBind(customerIdValue);
            dispatch(workOrderRepairObject(null));
          }
        }
      } catch (e) {
        console.error(e);
        dispatch(showMenuTabs(false));
        dispatch(savePreviousPage(props.location.pathname));
        props.history.push('/customerApiErrorPage');
      }
    })();
    dispatch(userNavigatedFrom(""));
    return () => {
      clearTimeout(timerId);
    };
  }, []);

  useEffect(() => {
    dispatch(workOrderRepairObject(null));
    dispatch(dmcWorkOrderRepairObject(null));
    dispatch(savingCalenderIndex([]));
    dispatch(savingcalenderTrackValue(""));
    dispatch(savingDmcCalenderIndex([]));
    dispatch(savingDmcCalenderTrackValue(""));
    dispatch(originalRepairAppointmentData(null));
    dispatch(dmcRepairAppointmentData(null));
    dispatch(calendarPageIndex(0));
    dispatch(originalRepairSelectedSlotData(null));
    dispatch(dmcRepairSelectedSlotData(null));
    dispatch(originalRepairAppointmentWillNotBeCreated(false));
    dispatch(dmcRepairAppointmentWillNotBeCreated(false));
    dispatch(userChosenResumeRepair(false));
    dispatch(resumeDraftRepair(false));
    dispatch(loadDuplicateRepairPage(false));
    dispatch(userCreatedNewRepair(null));
    dispatch(repairDefaultAssocitaedAsset(null));
    dispatch(resetHazardAssessmentData());
    if (isCatalyst !== undefined) {
      setCatalystCustomer(isCatalyst)
    }
    let timer = setTimeout(() => {
      getCaseCardRequiredToggle();
      getWorkOrderRequiredToggle();
      getFinancialReferralToggleValue();
    }, 4000);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  const handleChangeAssociate = (e: { target: { value: any } }) => {
    if (!e.target.value || e.target.value.trim() === "") {
      return;
    }
    setDefaultAssociatedAsset(e.target.value);
    dispatch(userChosenPropertyId(e.target.value));
    setAssetProperty(e.target.value);
    fetchGetRepairsData(e.target.value);
    checkforLandlordValues(e.target.value);
    getGasBoilerData(e.target.value);
  };

  const checkforLandlordValues = async (assetId: string) => {
    let isCatalystRegistrationAreas = false;
    const assetrResponse = await api.getAssetsByid(assetId);
    const appConfigLandlordValues = await api.GetAppConfigToggleValue(
      "LandlordValues"
    );

    const appCatalystRepairDisabledAreasValues = await api.GetAppConfigToggleValue(
      "CatalystRepairDisabledAreas"
    );

    const appCatalystRegistrationAreasValues = await api.GetAppConfigToggleValue(
      "CatalystRegistrationAreas"
    );
    dispatch(assetRegion(assetrResponse?.region));
    dispatch(boroughName(assetrResponse?.borough));
    if (!isUndefinedNullOrEmpty(assetrResponse?.region) && appCatalystRegistrationAreasValues.value.toLowerCase().includes(assetrResponse?.region.toLowerCase())) {
      isCatalystRegistrationAreas = true;
    }

    let appconfigLandlordValues = appConfigLandlordValues?.value;
    let associatesdata;
    try {
      associatesdata = await api.getCaseAssetAssociate(assetId);
      let currentLandlord =
        associatesdata?.associates?.landLord?.organisation?.name;
      let previousLandLord =
        associatesdata?.associates?.previousLandLord?.organisation?.name;
      if (isCatalystRegistrationAreas && (
        appconfigLandlordValues.includes(currentLandlord) ||
        appconfigLandlordValues.includes(previousLandLord))
      ) {
        const isCatalystDisabledArea = !isUndefinedNullOrEmpty(assetrResponse?.region) && appCatalystRepairDisabledAreasValues.value.toLowerCase().includes(assetrResponse?.region.toLowerCase());
        setCatalystRepairDisabledAreas(isCatalystDisabledArea);
        setCatalystCustomer(true);
        dispatch(validateCatalystCustomer(true));
        dispatch(validateCatalystDisabledArea(isCatalystDisabledArea));
      } else {
        setCatalystCustomer(false);
        dispatch(validateCatalystCustomer(false));
        dispatch(validateCatalystDisabledArea(false));
      }
    } catch (e: any) {
      console.log(e);
    }


  };

  const handleChangeOnBack = (e: any) => {
    if (!e || e.trim() === "") {
      return;
    }
    setDefaultAssociatedAsset(e);
    dispatch(userChosenPropertyId(e));
    setAssetProperty(e);
    fetchGetRepairsData(e);
  };

  const getCustomer360DetailsBind = async (customerId: string) => {
    try {
      if (customerId !== null && customerId !== undefined) {
        let customerResponse = new CustomerResponse();
        if (isNullOrUndefined(customerDetails)) {
          customerResponse = await api.getCustomer(customerId);
        }
        else {
          customerResponse = customerDetails;
        }
        dispatch(saveCustomerDetails(customerResponse));
        localStorage.setItem("external-identifier", customerResponse?.["external-identifier"]);
        const customerContactParamsEntry: Customer = new Customer();
        customerContactParamsEntry.workPhone =
          customerResponse?.addresses.telecomsAddresses.find(
            (a) => a.telecomsAddressType === "workPhone"
          )?.number || "";
        customerContactParamsEntry.mobilePhone =
          customerResponse?.addresses.telecomsAddresses.find(
            (a) => a.telecomsAddressType === "mobilePhone"
          )?.number || "";
        customerContactParamsEntry.homePhone =
          customerResponse?.addresses.telecomsAddresses.find(
            (a) => a.telecomsAddressType === "homePhone"
          )?.number || "";
        customerContactParamsEntry.email =
          customerResponse?.addresses.digitalAddresses.find(
            (a) => a.digitalAddressType === "email"
          )?.address || "";

        if (
          customerContactParamsEntry.mobilePhone == "" ||
          customerResponse?.person.name.givenName == "" ||
          customerContactParamsEntry.email == ""
        ) {
          setIsCustInfo(true);
        } else {
          setIsCustInfo(false);
        }
        setCustomerContact(customerContactParamsEntry);
        setCustResponse(customerResponse);
        dispatch(userProfileETag(customerResponse?.eTag));
        dispatch(
          userProfileData({ customerResponse, customerContactParamsEntry })
        );
        dispatch(
          saveCustomerphoneNumber(customerResponse.addresses.telecomsAddresses)
        );

        let tenancyResponse = await api.getTenancies(customerId);
        dispatch(selectedTenancyGroup(tenancyResponse?.[0]?.tenancyGroup))

        tenancyResponse = Helper.sortTenanciesByLatestResidentialStatus(tenancyResponse, customerResponse);

        const activeTenanciesSummaries =
          customerResponse?.tenanciesSummaries.filter(
            (ts) =>
              ts.tenancySummary.statuses.find(
                (s) => s.type === "isTenancyActive"
              )?.value === true
          );

        const tenancySummaryList: TenancySummary[] = [];
        if (tenancyResponse.length > 1) {
          tenancyResponse.map((ts: any) => {
            let tenancySummaryEntry: TenancySummary[] =
              activeTenanciesSummaries.filter(
                (x) => x.tenancySummary.tenancyId === ts.tenancyIdentifier
              );

            if (tenancySummaryEntry.length > 0) {
              tenancySummaryList.push(tenancySummaryEntry[0]);
            }
          });
        } else {
          tenancySummaryList.push(activeTenanciesSummaries[0]);
        }
        const tenancyType =
          tenancySummaryList[0]?.tenancySummary?.tenancyType;
        if (tenancyType) {
          if (
            tenancyType == TenancyTypeMappingEnum.AGENCY ||
            tenancyType == TenancyTypeMappingEnum.COM1 ||
            tenancyType == TenancyTypeMappingEnum.HMBY2010 ||
            tenancyType == TenancyTypeMappingEnum.OFFICE ||
            tenancyType == TenancyTypeMappingEnum.USENOCCU
          ) {
            setIsVisible("none");
          } else {
            setIsVisible("block");
          }
        }

        if (tenancySummaryList.length > 0) {
          let accountid =
            tenancySummaryList[0]?.tenancySummary?.paymentReference;

          if (accountid != null) {
            dispatch(userChosenAccountNumber(accountid));
            getAccountDetails(accountid);
          }
        }
        const activeTenanciesPremisesIds: Tenancies[] = tenancySummaryList
          .map((ts: any) => ts.tenancySummary.premisesIds)
          .flat();
        dispatch(saveAssetId(activeTenanciesPremisesIds[0]))
        const propertiesIds: string[] = [];
        const premisesList: RelatedPremisesType[] = [];
        try {
          const promises = activeTenanciesPremisesIds.map(async (item: any) => {
            return await api.getAssociatedAssets(item);
          });
          Promise.all(promises).then((results) => {
            activeTenanciesPremisesIds?.map(async (assetId: any) => {
              results.forEach((element) => {
                const resultF = element.filter(
                  (addressData) => addressData.id === assetId
                );

                if (resultF !== null) newAssociatedAssets.push(resultF);
              });
            });
            const associatedAssetsList: AssocitaedAssetsType[] = [];
            newAssociatedAssets?.map((addressData: any) => {
              addressData?.map((address: any) => {
                const associatedAssetsTypeEntry: AssocitaedAssetsType =
                  new AssocitaedAssetsType();

                associatedAssetsTypeEntry.key = address?.id;
                associatedAssetsTypeEntry.value =
                  address?.addresses?.postalAddresses[0]?.formattedAddress;
                associatedAssetsList.push(associatedAssetsTypeEntry);

              });
            });
            if (associatedAssetsList.length > 1) {
              setArea(true);
            } else {
              setArea(false);
            }
            // associatedAssetsList[0] will always be the default first selected tenency asset belonging to the customer
            handleChangeOnBack(associatedAssetsList[0]?.key)
            setDefaultAssociatedAsset(associatedAssetsList[0]?.key);
            dispatch(userChosenPropertyId(associatedAssetsList[0]?.key));
            setAssetProperty(associatedAssetsList[0]?.key);

            setAssociatedAssetsList(associatedAssetsList);
            checkforLandlordValues(associatedAssetsList[0]?.key);
            // Calling service overdue function after getting asset id
            getGasBoilerData(associatedAssetsList[0]?.key)
          });
        } catch (e) {
          console.error(e);
          setDefaultAssociatedAsset('');
        }

        const myMessagesResponse = await api.GetAppConfigToggleValue(
          "IsMyMessagesRequired"
        );
        if (myMessagesResponse) {
          setShowMyMessages(myMessagesResponse?.value);
        }

        const isCaseCardRequired = await api.GetAppConfigToggleValue("IsCaseCardRequired");

        if (isCaseCardRequired) {
          dispatch(appConfigCaseCardToggle(isCaseCardRequired?.value));
        }


        const responseValue = await api.GetAppConfigToggleValue(
          "IsRepairFullDescriptionRequired"
        );
        if (responseValue) {
          dispatch(appConfigToggle(responseValue?.value));
        }

        const covidResponseToggle = await api.GetAppConfigToggleValue(
          "isCovidQuestionRequired"
        );
        if (covidResponseToggle) {
          dispatch(appConfigCovidToggle(covidResponseToggle?.value));
        }

        const getvandalismToggleConfig = await api.GetAppConfigToggleValue(
          "isVandalismQuestionRequired"
        )
        if (getvandalismToggleConfig) {
          let vandalismToggleValue: boolean = getvandalismToggleConfig?.value.toLowerCase() == 'true' ? true : false
          dispatch(appConfigVandalismToggle(vandalismToggleValue));
        }
        const isDMCEnabledToggle = await api.GetAppConfigToggleValue(
          "MyPeabody:isDMQuestionnaireEnabled"
        );
        if (isDMCEnabledToggle) {
          let isDMCToggleValue: boolean = isDMCEnabledToggle?.value.toLowerCase() === 'true';
          dispatch(appConfigisDMCEnabledToggle(isDMCToggleValue));
        }

        const status =
          RepairStatusField.Appointed +
          "," +
          RepairStatusField.PendingApproval +
          "," +
          RepairStatusField.OnHold +
          "," +
          RepairStatusField.Cancelled +
          "," +
          RepairStatusField.Completed +
          "," +
          RepairStatusField.Unappointed +
          "," +
          RepairStatusField.InProgress +
          "," +
          RepairStatusField.InDiagnosis +
          "," +
          RepairStatusField.ReportedToEMA +
          "," +
          RepairStatusField.CatalystTier2Triage +
          "," +
          RepairStatusField.CatalystEMATriage +
          "," +
          RepairStatusField.CatalystDefectTriage +
          "," +
          RepairStatusField.AssignedtoManagingAgent;
        dispatch(
          userChosenPropertyId(
            tenancySummaryList[0]?.tenancySummary?.premisesIds[0]
          )
        );

        setAssetProperty(tenancySummaryList[0]?.tenancySummary?.premisesIds[0]);
        try {
          const associatedAssets = await api.getAssociatedAssets(
            tenancySummaryList[0]?.tenancySummary?.premisesIds[0]
          );
          associatedAssets.forEach((element) => {
            const premisesEntry: RelatedPremisesType =
              new RelatedPremisesType();
            premisesEntry.premisesType = element.assetType as PremisesType;
            premisesEntry.premisesTypeId = element.id;
            premisesList.push(premisesEntry);
            propertiesIds.push(element.id);
          });
          const areaOptions = premisesList.map((f) => ({
            key: f.premisesType,
            value: f.premisesTypeId,
          }));

          areaOptions.forEach((element) => {
            if (element.key === "Property" || element.key === "Block") {
              assetBlockPropertyIds.push(element.value);
            }
            if (element.key === "Block") {
              dispatch(getBlockIdentifier(element.value))
            }
          });

          let assetIDsIntTxt = "assetIdentifiers=";
          let assetIDsRemTxt = assetBlockPropertyIds.join("&assetIdentifiers=");
          let assetIDsAll = assetIDsIntTxt.concat(assetIDsRemTxt);
          setassetIdentifiersAll(assetIDsAll);
          dispatch(getAllAssetIdentifiers(assetIDsAll));
        } catch (e) {
          console.error(e);
          setDefaultAssociatedAsset('');
        }

        let tenancyStartDate =
          tenancySummaryList[0]?.tenancySummary?.tenancyStartDate;
        if (tenancyStartDate == undefined) {
          tenancyStartDate = "";
        }
        const newList: RelatedPremisesType[] = premisesList.filter(
          (item) => item.premisesType === PremisesType.Property
        );
        try {
          if (newList.length > 0) {
            const queryParamsFirst = {
              propertiesIds: propertiesIds.filter(
                (item) => item === newList[0].premisesTypeId
              ),
              orderBy: "raisedDate desc",
              raisedSince: tenancyStartDate,
              priority: "",
              status,
              limit: 1,
            };
            const worksOrdersRepairFirst = await api.getWorksOrdersApi(
              queryParamsFirst
            );

            const queryParamsSecond = {
              propertiesIds: propertiesIds.filter(
                (item) => item !== newList[0].premisesTypeId
              ),
              orderBy: "raisedDate desc",
              raisedSince: tenancyStartDate,
              priority: "",
              status,
              limit: 1,
            };
            if (queryParamsSecond.propertiesIds.length > 0) {
              const worksOrdersRepairSecond = await api.getWorksOrdersApi(
                queryParamsSecond
              );

              if (worksOrdersRepairFirst.totalCount > 0) {
                worksOrdersRepairSecond.worksOrders.push(
                  worksOrdersRepairFirst.worksOrders[0]
                );
              }
              Promise.all([worksOrdersRepairSecond]).then((results) => {
                results.map((items) => {
                  const data = new RepairsResponse(items);
                  dampAndMouldDescription(data.models)
                  setRepairList(data.models);
                });
              });
            }
            else {
              Promise.all([worksOrdersRepairFirst]).then((results) => {
                results.map((items) => {
                  const data = new RepairsResponse(items);
                  dampAndMouldDescription(data.models)
                  setRepairList(data.models);
                });
              });
            }
          } else {
            const queryParams = {
              propertiesIds,
              orderBy: "raisedDate desc",
              raisedSince: tenancyStartDate,
              priority: "",
              status,
              limit: 1,
            };
            const worksOrdersRepair = await api.getWorksOrdersApi(queryParams);
            Promise.all([worksOrdersRepair]).then((results) => {
              results.map((items) => {
                const data = new RepairsResponse(items);
                dampAndMouldDescription(data.models)
                setRepairList(data.models);
              });
            });
          }
        }
        catch (e) {
          console.error(e);
          setIsRepairsCardError(true);
        }
      }
    } catch (e) {
      console.error(e);
      dispatch(showMenuTabs(false));
      dispatch(savePreviousPage(props.location.pathname));
      props.history.push('/customerApiErrorPage');
    }
  };

const resolveTransactionBalanceType = (balance: number | null, paymentCode: string | null): string => {
  if (balance === 0 || paymentCode == null) return "";
  return paymentCode === "DR" ? "Debit" : "Credit";
};

const resolveTransactionLiveBalanceType = (balance: number | null, paymentCode: string | null): string => {
  if (balance === 0 || paymentCode == null) return "";
  return paymentCode !== "DR" ? "Payment received" : "Charge applied";
};

const buildTransactDetails = (transaction: any): TransactDeatils => {
  const details = new TransactDeatils();
  const balance = transaction?.amount?.net?.value ?? null;
  const paymentCode = transaction?.["payment-code"] ?? null;

  const resolveTransactionBalance = (value: number | null): number => {
    if (value == null) return 0;
    return value < 0 ? Math.abs(value) : value;
  };

  details.LiveBalance = resolveTransactionBalance(balance);
  details.transactiondate = transaction?.dates?.["transaction-date"];
  details.TransactionBalanceType = resolveTransactionBalanceType(balance, paymentCode);
  details.LiveBalanceType = resolveTransactionLiveBalanceType(balance, paymentCode);

  return details;
};

const resolveAccountLiveBalanceType = (liveBalanced: any, i: number): string => {
  if (liveBalanced == 0) return "";
  return i > 0 ? " in arrears" : " in credit";
};

const processLiveBalance = (accountDetails: AccountDetails, balance: any) => {
  const liveBalanced = balance["monetary-amount"]["value"];
  const i = parseInt(liveBalanced);

  accountDetails.LiveBalanceType = i == null ? "" : resolveAccountLiveBalanceType(liveBalanced, i);

  const cleanedValue = liveBalanced == null ? null : liveBalanced.toString().replaceAll(",", "");
  const number = cleanedValue == null ? 0: Math.abs(cleanedValue);
  accountDetails.LiveBalance = number.toFixed(2);

  if (i != null && i > 0) {
    setIsArrear(true);
    setBalanceCss("error-color pb-20");
  } else {
    setIsArrear(false);
    setBalanceCss("color-black pb-20");
  }
};

const getAccountDetails = async (accountid: string) => {
  if (accountid == null) return;

  try {
    const accountBalance = await api.getAccount(accountid);

    const ucFlagRaw = accountBalance?.["other-fields"]?.find((field: any) => field?.key === "UC_FLAG")?.value;
    const ucFlagValue = String(ucFlagRaw ?? "").trim().toUpperCase() === "Y";
    dispatch(saveCustomerUCFlag(ucFlagValue));
    dispatch(saveCustomerRentDetails(accountBalance));

    if (accountBalance == null) {
      setIsAccount(false);
      return;
    }

    const accountDetails = new AccountDetails();

    accountBalance["balance"].forEach((balance: any) => {
      if (balance["balance-type"] === BalanceType.Livebalanced) {
        processLiveBalance(accountDetails, balance);
      }
    });

    const transactions = await api.getTransactionsSearch(accountid, 3, 0, "", "", "");
    const transactionList = transactions.transactions;

    [0, 1, 2].forEach((index) => {
      accountDetails.transactDeatils.push(buildTransactDetails(transactionList[index]));
    });

    setAccountDetails(accountDetails);
    setIsAccount(true);
    setIsLoading(false);
  } catch (e) {
    setIsAccount(false);
    setIsLoading(false);
    console.error(e);
  }
};
  const fetchGetRepairsData = (defaultAssociatedAsset: string) => {
    if (!defaultAssociatedAsset || defaultAssociatedAsset.trim() === "") {
      return;
    }
    let status =
      RepairStatusField.Appointed +
      "," +
      RepairStatusField.PendingApproval +
      "," +
      RepairStatusField.OnHold +
      "," +
      RepairStatusField.Cancelled +
      "," +
      RepairStatusField.Completed +
      "," +
      RepairStatusField.Unappointed +
      "," +
      RepairStatusField.InProgress +
      "," +
      RepairStatusField.InDiagnosis +
      "," +
      RepairStatusField.ReportedToEMA;

    (async () => {
      try {
        const propertiesIds: string[] = [];
        const premisesList: RelatedPremisesType[] = [];
        dispatch(saveAssetId(defaultAssociatedAsset))
        const AssetList = await api.getAssociatedAssets(defaultAssociatedAsset);
        if (!Array.isArray(AssetList) || AssetList.length === 0) {
          setIsRepairsCardError(true);
          return;
        }
        dispatch({ type: CASE_SELECTED_TENANCY, payload: AssetList });
        AssetList.forEach((element) => {
          const premisesEntry: RelatedPremisesType = new RelatedPremisesType();
          premisesEntry.premisesType = element.assetType as PremisesType;
          premisesEntry.premisesTypeId = element.id;
          premisesList.push(premisesEntry);
          propertiesIds.push(element.id);
        });
        let tenancyStartDate = "";
        const activeTenanciesSummaries =
          custResponse?.tenanciesSummaries.filter(
            (ts) =>
              ts.tenancySummary.statuses.find(
                (s) => s.type === "isTenancyActive"
              )?.value === true
          );

        if (
          activeTenanciesSummaries != undefined &&
          activeTenanciesSummaries != null
        ) {
          let TenancySummaryEntry = activeTenanciesSummaries.find(
            (st) => st.tenancySummary.premisesIds[0] === defaultAssociatedAsset
          );

          if (TenancySummaryEntry != undefined && TenancySummaryEntry != null) {
            let paymentReference =
              TenancySummaryEntry?.tenancySummary?.paymentReference;
            if (paymentReference != undefined && paymentReference != null) {
               getAccountDetails(paymentReference);
              }
            if (TenancySummaryEntry?.tenancySummary.tenancyStartDate != null) {
              tenancyStartDate =
                TenancySummaryEntry?.tenancySummary.tenancyStartDate;
            }
          }

          const tenancyType =
            activeTenanciesSummaries[0]?.tenancySummary?.tenancyType;
          if (tenancyType) {
            if (
              tenancyType == TenancyTypeMappingEnum.AGENCY ||
              tenancyType == TenancyTypeMappingEnum.COM1 ||
              tenancyType == TenancyTypeMappingEnum.HMBY2010 ||
              tenancyType == TenancyTypeMappingEnum.OFFICE ||
              tenancyType == TenancyTypeMappingEnum.USENOCCU
            ) {
              setIsVisible("none");
            } else {
              setIsVisible("block");
            }
          }
        }
        const newList: RelatedPremisesType[] = premisesList.filter(
          (item) => item.premisesType === PremisesType.Property
        );
        try {
          if (newList.length > 0) {
            const queryParamsFirst = {
              propertiesIds: propertiesIds.filter(
                (item) => item === newList[0].premisesTypeId
              ),
              orderBy: "raisedDate desc",
              raisedSince: tenancyStartDate,
              priority: "",
              status,
              limit: 1,
            };
            const worksOrdersRepairFirst = await api.getWorksOrdersApi(
              queryParamsFirst
            );
            const queryParamssecond = {
              propertiesIds: propertiesIds.filter(
                (item) => item !== newList[0].premisesTypeId
              ),
              orderBy: "raisedDate desc",
              raisedSince: tenancyStartDate,
              priority: "",
              status,
              limit: 1,
            };
            if (queryParamssecond.propertiesIds.length > 0) {
              const worksOrdersRepairSecond = await api.getWorksOrdersApi(
                queryParamssecond
              );
              if (worksOrdersRepairFirst.totalCount > 0) {
                worksOrdersRepairSecond.worksOrders.push(
                  worksOrdersRepairFirst.worksOrders[0]
                );
              }
              Promise.all([worksOrdersRepairSecond]).then((results) => {
                results.map((items) => {
                  const data = new RepairsResponse(items);
                  dampAndMouldDescription(data.models)
                  setRepairList(data.models);
                });
              });
            }
            else {
              Promise.all([worksOrdersRepairFirst]).then((results) => {
                results.map((items) => {
                  const data = new RepairsResponse(items);
                  dampAndMouldDescription(data.models)
                  setRepairList(data.models);
                });
              });
            }
          } else {
            const queryParams = {
              propertiesIds,
              orderBy: "raisedDate desc",
              raisedSince: tenancyStartDate,
              priority: "",
              description: "",
              status,
              limit: 1,
            };
            const worksOrdersRepair = await api.getWorksOrdersApi(queryParams);
            Promise.all([worksOrdersRepair]).then((results) => {
              results.map((items) => {
                const data = new RepairsResponse(items);
                dampAndMouldDescription(data.models)
                setRepairList(data.models);
              });
            });
          }
        }
        catch (e) {
          console.error(e);
          setIsLoading(false)
          setIsRepairsCardError(true);
        }
      } catch (e) {
        console.error(e);
        setDefaultAssociatedAsset('');
      }
    })();
  };

  const callViewAccountHandler = async () => {
    dispatch(selectedTabValue("viewaccount"))
    dispatch(userNavigatedFrom(""));
    props.history.push("/viewaccount");
  };

  const manageProfileHandler = () => {
    dispatch(selectedTabValue("manageprofile"));
    dispatch(userNavigatedFrom(""));
    props.history.push("/manageprofile");
  };

  const callPageHandler = async () => {
    dispatch(DMCChecksavedAnswer(""));
    dispatch(RemoveAllDMCData(null));
    dispatch(showMenuTabs(false));
    dispatch(showFooter(false));
    dispatch(userNavigatedFrom(""));
    dispatch(getDeterminedContractorDetails(null));
    props.history.push("/repairproperty");
  };
  const callHistoricRepairsPageHandler = () => {
    dispatch(workOrderRepairObject(null));
    dispatch(userNavigatedFrom(""));
    dispatch(selectedTabValue("historicRepairs"))
    props.history.push("/historicRepairs");
  };
  const clearReduxStore = () => {
    dispatch(workOrderRepairObject(null));
    dispatch(dmcWorkOrderRepairObject(null));
    dispatch(userChosenPropertyId(""));
    dispatch(userChosenPropertyType(""));
    dispatch(userChosenPropertyAddress(""));
    dispatch(userChosenRepairLocationId(0));
    dispatch(userChosenRepairLocation(""));
    dispatch(userChosenUPRN(""));
    dispatch(userChosenSOR(""));
    dispatch(userChosenSTATUS(""));
    dispatch(userChosenEligibilityErrorCode(""));
    dispatch(userChosenContactPhone(""));
    dispatch(userChosenContactName(""));
    dispatch(userChosenRelationDetails(""));
    dispatch(userChosenIsReporter(false));
    dispatch(userChosenIsError(false));
    dispatch(repairHistoryData(""));
    dispatch(repairSearchTerm(""));
    dispatch(defaultSearchRepairStatus(""));
    dispatch(defaultSearchArea(""));
    dispatch(defaultSearchSortByOrder(""));
    dispatch(clearMediaFiles([]));
    dispatch(showMenuTabs(true));
    dispatch(showFooter(true));
    dispatch(repairDefaultAssocitaedAsset(null));
    dispatch(getHeatingHotWaterCase(null));
    dispatch(isMyPbRepairsMaintainence(""));
    dispatch(userGetRepairData(""));
    dispatch(saveSupplimentaryCodes(""));
    dispatch(saveEmailCopyRadioValue(""));
    dispatch(saveHHSRSAssessmentCompleted(false));
  };
  const handleFinancialReferral = () => {
    dispatch(clearReferralInformation({}))
    props.history.push('/enquiryconsent')
  }
  const clearStoreAfterFinishingJourney = () => {
    dispatch(userChosenHighLevelDescription(""));
    dispatch(userChosenSupplementaryQuestions(""));
    dispatch(userChosenEmergencyQuestion(""));
    dispatch(userChosenDuplicateQuestion(""));
    dispatch(userChosenAdditionalDescription(""));
    dispatch(userChosenVandalismQuestion("No"));
    dispatch(userChosenVandalismAdditionalInformation(""));
    dispatch(userChosenCovidQuestion(""));
    dispatch(userChosenVulnerabilityQuestion("No"));
    dispatch(userChosenVulnerabilityAdditionalInformation(""));
    dispatch(userChosenContactDetails(""));
    dispatch(userChosenEligibilityErrorCode(""));
    dispatch(selectedTenacyType(""));
    dispatch(getReferenceNumber(""));
    dispatch(getPrefferenceNumber(false));
    dispatch(saveSelectedSlotDate(""));
    dispatch({ type: CLEAR_CASE_STATE });
    dispatch({ type: CASE_SELECTED_ANSWERS });
  }

  const removeCasesAndRepairData = () => {
    dispatch(comingFromCaseJourneySuccess(false))
    dispatch(comingFromRepairJourneySuccess(false))
    dispatch(setTriageRepair(false));
    clearStoreAfterFinishingJourney()
  }

  const openMobiledialer = () => {
    window.open('tel:' + t('phone_no'));
  };

  return (
    <div role="button" onClick={removeCasesAndRepairData} onKeyPress={removeCasesAndRepairData}>
      <div className="heading-Peabody">
        <h1>{t("Welcome_to_My_Peabody")}</h1>
        <h6 className="padding-paragraph">
          {" "}
          {t("Customer360Title")}{" "}
        </h6>
      </div>
      {EICRserviceAlert && EICRCardToggleValue === "true" && (
        <div className='padding-repair payment-error mt-4'>
          <Message className="error-msg">{EICRserviceAlert}
          </Message>    </div>
      )}
      {GASserviceAlert && DGASCardToggleValue === "true" && (
        <div className='padding-repair ipad-space'>
          <Message className="error-msg">{GASserviceAlert}
          </Message>    </div>
      )}

      <div className="padding-repair">
        <SuccessMessage {...props} />
        {!isLoading ? (
          <div>

            {isUserRegistered && (
              <Message data-testid="messageSuccess" className="success-msg">
                {t("Register_Success_Msg")}
              </Message>)
            }

            <div className="search-addressdd">

              {area ? (

                <>

                  <select
                    data-testid="repairs-address"
                    className="text-select repairs-search-address1"
                    value={defaultAssociatedAsset}
                    id={"repairs-search-address" + 1}
                    onChange={handleChangeAssociate}
                    title="repair address"
                  >
                    {associatedAssetList.map((e, key) => {
                      dispatch(userChosenPropertyId(defaultAssociatedAsset));
                      return (
                        <option key={key} value={e.key}>
                          {" "}
                          {e.value.length > 84
                            ? e.value.slice(0, 84) + ".."
                            : e.value}
                        </option>
                      );
                    })}
                  </select>

                </>
              ) : (
                <div
                  data-testid="repairs-search-address1"
                  id="repairs-search-address1"
                  className="repairs-search-address1"
                >
                  {associatedAssetList.map((e, key) => {
                    return (
                      <div className="text-tenancy">
                        {e.value}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 mb-30" data-testid="work-order">
              {!catalystRepairDisabledAreas || (catalystRepairDisabledAreas && catalystWorkOrderToggle === "true") ?
                (!isRepairsCardError ? (
                  <div className="body-card row m-0 border-terracotta display-column">
                    <h4>
                      {t("Repairs_card")}{" "}
                    </h4>
                    {isMyPBMaintenance &&
                      <div className="warning-pre-line alert p-0 mb-8 mt-local-1">
                        <div className="w-full px-2 py-2 bg-purple-20 flex items-center">
                          <div className="px-4 pr-8"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" className="text-purple-100 w-6 h-6">
                            <path d="M480 179.6C498.6 188.4 512 212.1 512 240C512 267.9 498.6 291.6 480 300.4V448C480 460.9 472.2 472.6 460.2 477.6C448.3 482.5 434.5 479.8 425.4 470.6L381.7 426.1C333.7 378.1 268.6 352 200.7 352H192V480C192 497.7 177.7 512 160 512H96C78.33 512 64 497.7 64 480V352C28.65 352 0 323.3 0 288V192C0 156.7 28.65 128 64 128H200.7C268.6 128 333.7 101 381.7 53.02L425.4 9.373C434.5 .2215 448.3-2.516 460.2 2.437C472.2 7.39 480 19.06 480 32V179.6zM200.7 192H192V288H200.7C280.5 288 357.2 317.8 416 371.3V108.7C357.2 162.2 280.5 192 200.7 192V192z"></path></svg>
                          </div>
                          <div className="flex items-center">
                            <p className="w-full text-left my-2 font-AvantGardeGothic-Md">
                              <div className="fw-bold">{t("repairs_Maintenance_Message")}</div>
                            </p>
                          </div>
                        </div>
                      </div>
                    }
                    {!repairList.length ? (
                      <div className="col-md-12 p-0">
                        <div className="pt-24 pb-20">
                          <strong>{t("NO_repairs_listed")}</strong>
                        </div>
                        <p>
                          {t("NO_repairs")}
                        </p>
                      </div>
                    ) : (
                      repairList.map((el, key) => (
                        <div key={key} className="col-md-12 p-0 border-none">
                          <h5 className="pt-24 pb-20">
                            {t("recent_repair")}
                            <span className="text-transformation">
                              {RepairBlockMap[el.area as keyof typeof RepairBlockMap] ?? ""}
                            </span>
                          </h5>
                          <div className="record-repair justify-between">
                            <h6>{t("historic_repairs_dates")}</h6>
                            <p>{formatDate(el.raisedDate)}</p>
                          </div>
                          <div className="record-repair justify-between pt-16 pb-16">
                            <h6>{t("historic_repairs_status")}</h6>
                            <p>
                              {(() => {
                                const isUnknownEmaTriage =
                                  el.siteIndentifire === EMAContractorType.UNKNOWN_EMA_TRIAGE ||
                                  el.siteIndentifire === EMAContractorType.EMA_UNKNOWN_CONTACTDETAILS_TRIAGE;

                                const isAssignedContractor =
                                  el.status === RepairStatusField.Unappointed || el.status === "Reported to EMA";

                                const isCatalystTriage =
                                  el.status === RepairStatusField.CatalystTier2Triage ||
                                  el.status === RepairStatusField.CatalystDefectTriage ||
                                  el.status === RepairStatusField.CatalystEMATriage;

                                if (isUnknownEmaTriage) {
                                  return RepairStatusField.RepairStatusFieldCatalyst;
                                }

                                if (isAssignedContractor) {
                                  return RepairStatusField.Assignedcontractor;
                                }

                                if (isCatalystTriage) {
                                  return RepairStatusField.RepairStatusFieldCatalyst;
                                }

                                return el.status;
                              })()}
                            </p>
                          </div>
                          <div className="record-repair justify-between">
                            <h6>{t("historic_repairs_description")} </h6>
                            <p>
                              {" "}
                              {
                                el.channel !== RepairChannel.CustomerSelfService &&
                                  el.channel !== RepairChannel.ERGO &&
                                  el.channel !== RepairChannel.ColleagueSelfService
                                  ? (el.trade === 'Unknown' ? t('RepairDescription_ErrorMessage')
                                    : el.trade) : appConfigValue ? el.description
                                    : el.description?.split('.')[0]
                              }
                            </p>
                          </div>
                        </div>
                      ))
                    )}
                    <div className="col-md-12 marginTop-auto">
                      <div className="row pe-0 repair-btn">
                        {repairList.length ? (
                          <div
                            className="col pt-30 pe-0"
                            id="common-btn-id"
                          >
                            <Button onClick={callHistoricRepairsPageHandler} id="cust360-btn1" className="secondary-ghost-btn"> {t("View_Repair")}</Button>
                          </div>
                        ) :
                          (<div className="col text-end pt-30 pe-0">
                            <Button data-testid="repairs-Create" onClick={callPageHandler} disabled={isMyPBMaintenance ? true : false} id={"repairs-Create" + 1} className="secondary-ghost-btn">{t("Create_repair")}</Button>
                          </div>
                          )
                        }
                        {repairList.length ? (
                          <div className="col text-end pt-30 pe-0">
                            <Button data-testid="repairs-Create" onClick={callPageHandler} disabled={isMyPBMaintenance ? true : false} id={"repairs-Create" + 1} className="secondary-ghost-btn">{t("Create_repair")}</Button>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="body-card row m-0 border-terracotta display-column">
                    <h4>
                      {t("Repairs_card")}{" "}
                    </h4>
                    {isMobile ? (
                      <div>
                        <Message className='error-msg'>
                          {t('retrieve_repair_Error_Message')}
                          <span className='underline'
                            onKeyDown={openMobiledialer}
                            onClick={openMobiledialer}
                          >
                            {t('phone_no')}
                          </span>
                        </Message>
                      </div>
                    ) : (
                      <div>
                        <Message className='error-msg'>
                          {t('retrieve_repair_Error_Message')}
                          <span>
                            {t('phone_no')}
                          </span>
                        </Message>
                      </div>
                    )}
                  </div>
                )) : (
                  ""
                )}

              <div
                data-testid="Balance_Card"
                className="body-card row m-0 border-blue display-column"
              >
                {isAccount ? (
                  <>
                    <h4>
                      {t("Balance_card")}{" "}
                    </h4>
                    <div className="col-md-12 p-0">
                      <h5 className="pt-24 pb-20">
                        {t("your_rent_service_account")}
                      </h5>

                      {!accountDetails?.transactDeatils[0].LiveBalance ||
                        !accountDetails?.transactDeatils[0].transactiondate ? (
                        <h5 className="error-color">
                          {t("CR047")}
                        </h5>

                      ) : (
                        <>
                          <h5 className={balanceCss}>
                            {
                              isArrear ? (
                                <>
                                  (£
                                  {accountDetails?.LiveBalance == "0"
                                    ? "0.00"
                                    : parseFloat(
                                      accountDetails?.LiveBalance
                                    ).toLocaleString(undefined, {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2,
                                    })}
                                  ) </>

                              ) : (
                                <>
                                  £
                                  {accountDetails?.LiveBalance == "0"
                                    ? "0.00"
                                    : parseFloat(
                                      accountDetails?.LiveBalance
                                    ).toLocaleString(undefined, {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2,
                                    })} </>
                              )
                            }
                            {accountDetails?.LiveBalanceType}
                            {" "}
                          </h5>
                          {accountDetails?.transactDeatils[0].LiveBalance ? (
                            <>
                              <div className="record-repair justify-between">
                                <h6>

                                  {" "}
                                  {
                                    accountDetails?.transactDeatils[0]
                                      .LiveBalanceType
                                  }{" "}
                                </h6>
                                <h6>
                                  {Number((String(accountDetails?.transactDeatils[0].LiveBalance)).replace(/[^-.0-9]+/g, '')) < 0
                                    ? "-" : "+"}
                                  £
                                  {accountDetails?.transactDeatils[0]
                                    .LiveBalance == 0
                                    ? "0.00"
                                    : Number((String(accountDetails?.transactDeatils[0].LiveBalance)).replace(/[^-.0-9]+/g, '')) > 0 ? accountDetails?.transactDeatils[0].LiveBalance.toLocaleString(
                                      undefined,
                                      {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2,
                                      }
                                    ) : (-1 * Number((String(accountDetails?.transactDeatils[0].LiveBalance)).replace(/[^-.0-9]+/g, ''))).toLocaleString(
                                      undefined,
                                      {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2,
                                      }
                                    )}
                                </h6>
                              </div>
                              <div className="record-repair justify-between">
                                <p>
                                  {formatDate(
                                    accountDetails?.transactDeatils[0]
                                      .transactiondate || ""
                                  )}
                                </p>
                                <p>

                                  {
                                    accountDetails?.transactDeatils[0]
                                      .TransactionBalanceType
                                  }
                                  {" "}
                                </p>
                              </div>
                            </>
                          ) : (
                            ""
                          )}

                          {accountDetails?.transactDeatils[1].LiveBalance ? (
                            <>
                              <div className="record-repair justify-between pt-16">
                                <h6>

                                  {" "}
                                  {
                                    accountDetails?.transactDeatils[1]
                                      .LiveBalanceType
                                  }{" "}
                                </h6>
                                <h6>
                                  {Number((String(accountDetails?.transactDeatils[1].LiveBalance)).replace(/[^-.0-9]+/g, '')) < 0
                                    ? "-" : "+"}
                                  £
                                  {accountDetails?.transactDeatils[1]
                                    .LiveBalance == 0
                                    ? "0.00"
                                    : Number((String(accountDetails?.transactDeatils[1].LiveBalance)).replace(/[^-.0-9]+/g, '')) > 0 ? accountDetails?.transactDeatils[1].LiveBalance.toLocaleString(
                                      undefined,
                                      {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2,
                                      }
                                    ) : (-1 * Number((String(accountDetails?.transactDeatils[1].LiveBalance)).replace(/[^-.0-9]+/g, ''))).toLocaleString(
                                      undefined,
                                      {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2,
                                      }
                                    )}
                                </h6>
                              </div>
                              <div className="record-repair justify-between">
                                <p>
                                  {formatDate(
                                    accountDetails?.transactDeatils[1]
                                      .transactiondate || ""
                                  )}
                                </p>
                                <p>
                                  {
                                    accountDetails?.transactDeatils[1]
                                      .TransactionBalanceType
                                  }
                                  {" "}
                                </p>
                              </div>


                            </>
                          ) : (
                            ""
                          )}

                          {accountDetails?.transactDeatils[2].LiveBalance ? (
                            <>
                              <div className="record-repair justify-between  pt-16">
                                <h6>
                                  {
                                    accountDetails?.transactDeatils[2]
                                      .LiveBalanceType
                                  }{" "}
                                </h6>
                                <h6>
                                  {Number((String(accountDetails?.transactDeatils[2].LiveBalance)).replace(/[^-.0-9]+/g, '')) < 0
                                    ? "-" : "+"}
                                  £
                                  {accountDetails?.transactDeatils[2]
                                    .LiveBalance == 0
                                    ? "0.00"
                                    : Number((String(accountDetails?.transactDeatils[2].LiveBalance)).replace(/[^-.0-9]+/g, '')) > 0 ? accountDetails?.transactDeatils[2].LiveBalance.toLocaleString(
                                      undefined,
                                      {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2,
                                      }
                                    ) : (-1 * Number((String(accountDetails?.transactDeatils[2].LiveBalance)).replace(/[^-.0-9]+/g, ''))).toLocaleString(
                                      undefined,
                                      {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2,
                                      }
                                    )}
                                </h6>
                              </div>
                              <div className="record-repair justify-between">
                                <p>
                                  {formatDate(
                                    accountDetails?.transactDeatils[2]
                                      .transactiondate || ""
                                  )}
                                </p>
                                <p>
                                  {
                                    accountDetails?.transactDeatils[2]
                                      .TransactionBalanceType
                                  }
                                  {" "}
                                </p>
                              </div>

                            </>
                          ) : (
                            ""
                          )}

                        </>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="p-0"
                      data-testid="No_Balance_Card"
                    >
                      <h4>
                        {t("Balance_card")}{" "}
                      </h4>
                    </div>
                    <div className="col-md-12 p-0">
                      {isMobile ? (
                        <div>
                          <Message className='error-msg'>{t('account_Down_SSC001')} <span className='underline' onKeyDown={openMobiledialer} onClick={openMobiledialer}>
                            {t('phone_no')}
                          </span>
                          </Message>
                        </div>
                      ) : (
                        <div>
                          <Message className='error-msg'>{t('account_Down_SSC001')} <span>{t('phone_no')}</span>
                          </Message>
                        </div>
                      )}
                    </div>
                  </>
                )}
                {isAccount && <div className="col-md-12 marginTop-auto">
                  <div className="row pe-0 repair-btn">
                    <div style={{ display: isVisible }} className="col pt-30 pe-0">
                      <Button id="view-account" data-testid="view-account" onClick={callViewAccountHandler} className="secondary-ghost-btn">{t("View_Accounts")}</Button>
                    </div>
                    <div className="col text-end pt-30 pe-0">
                      {((!isCatalyst && financialReferralToggle === "true") || financialReferralToggle === "false") &&
                        <Button id="repairs-Create" data-testid="repairs-Create" className="secondary-ghost-btn" onClick={handleFinancialReferral}>
                          {t("Financial_FI001")}{" "}
                        </Button>
                      }
                    </div>
                  </div>
                </div>}
              </div>
              {showMyMessages === 'true' && <MyMessagesCard {...props} associatedAssetList={assetIdentifiersAll} />}
              {loggedInStatus && blockAssetId && <HighRise {...props} />}
              <div className="body-card row m-0 border-yellow display-column">
                <div className="p-0">
                  <h4>
                    {" "}
                    {t("Your_details")}{" "}
                  </h4>
                  <div className="col-md-12 p-0">
                    <h5 className="pt-24 pb-20">
                      {t("personal_details")}
                    </h5>
                    <div className="record-repair justify-between pb-16">
                      <h6> {t("Name")} </h6>
                      <p data-hj-suppress="">
                        {custResponse?.person.name.title}{" "}
                        {custResponse?.person.name.givenName}{" "}
                        {custResponse?.person.name.surname}
                      </p>
                    </div>
                    <div className="record-repair justify-between pb-16">
                      <h6> {t("Email")}</h6>
                      <p>
                        {customerContact?.email ? customerContact?.email : "-"}
                      </p>
                    </div>
                    <div className="record-repair justify-between pb-16">
                      <h6> {t("Mobile")}</h6>
                      <p>
                        {customerContact?.mobilePhone
                          ? customerContact?.mobilePhone
                          : "-"}
                      </p>
                    </div>
                    {customerContact?.homePhone ? (
                      <div className="record-repair justify-between pb-16">
                        <h6> {t("Home")}</h6>
                        <p>{customerContact?.homePhone}</p>
                      </div>
                    ) : (
                      ""
                    )}
                    {customerContact?.workPhone ? (
                      <div className="record-repair justify-between pb-16">
                        <h6> {t("Business")}</h6>
                        <div>{customerContact?.workPhone}</div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  {!isCustInfo ? (
                    <div></div>
                  ) : (
                    <div className="record-repair justify-between ">
                      <p className="text-start ps-0">
                        {t("missing_information_profile")}
                      </p>
                    </div>
                  )}
                </div>
                <div className="col-md-12 marginTop-auto">
                  <div className="row pe-0 repair-btn">
                    <div className="col ps-0 pt-30">
                      <a
                        id="manage_profile"
                        data-testid="manage_profile"
                        className="secondary-ghost-btn"
                        onClick={manageProfileHandler}
                      >
                        {t("Edit_your_details")}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="body-card row m-0 border-lightblue display-column">

                <h4>{catalystCustomer ? t("SSCP006") : t("Save_bills")}</h4>
                <div className="col-md-12 p-0">

                  <img src={catalystCustomer ? catalystlogo : logo} alt="Volunterring" className="pt-24 w-100" />

                  <p className="pt-24">{catalystCustomer ? t("SSCP007") : t("Saving_money")}</p>
                </div>

                <div className="col-md-12 marginTop-auto">
                  <div className="row pe-0 repair-btn">
                    <div className="col ps-0 pt-30">

                      {catalystCustomer ?
                        <Button data-testid="button-Getting" id={"button-Getting1" + 1} onClick={() =>
                          window.open(
                            "https://www.peabody.org.uk/your-home/",
                            "_blank",
                            "noopener"
                          )
                        } className="secondary-ghost-btn">{t("Find_out_more")}</Button>
                        : <Button id={"button-Getting1" + 1} data-testid="button-Getting" onClick={() =>
                          window.open(
                            "https://www.peabody.org.uk/resident-services/benefits-and-budgeting/book-your-free-energy-advice-session",
                            "_blank",
                            "noopener"
                          )
                        } className="secondary-ghost-btn">{t("Find_out_more")}</Button>
                      }
                    </div>
                  </div>
                </div>

              </div>
              {appCaseCardconfigValue == "true" &&
                assetProperty &&
                !catalystCustomer && <CaseCard {...props} defaultAssociatedAsset={defaultAssociatedAsset} />}
              {appCaseCardconfigValue == "true" &&
                assetProperty &&
                catalystCustomer &&
                catalystCaseCardToggle === "true" && <CaseCard {...props} defaultAssociatedAsset={defaultAssociatedAsset} />}



              {GASPropsData?.length > 0 && DGASCardToggleValue === "true" && <GasBoilerServicing GASPropsData={GASPropsData} {...props} />}
              {EICRropsData?.length > 0 && EICRCardToggleValue === "true" && <EICRCard EICRPropsData={EICRropsData} {...props} />}
            </div>
          </div>
        ) : (
          <div className="SpinnerWrapper">
            <LoadingSpinner />
          </div>
        )}
      </div>
    </div>
  );
};
export default Customer360View;